<section class="team-form-page">
  <header class="form-header">
    <a class="back-link" routerLink="/dashboard/teams">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      <span>К списку команд</span>
    </a>
    <h1>{{ title }}</h1>
  </header>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <form class="team-form" (ngSubmit)="saveTeam()">
    <section class="form-card">
      <h2>Данные команды</h2>
      <div class="form-grid">
        <label>
          <span>Название команды</span>
          <input class="form-control" name="name" placeholder="Авангард" [(ngModel)]="formData.name" required>
        </label>
        <label>
          <span>Slug</span>
          <input class="form-control" name="slug" placeholder="hc_avangard" [(ngModel)]="formData.slug" required>
        </label>
        <label>
          <span>Чемпионат</span>
          <select class="form-control" name="championshipId" [(ngModel)]="formData.championshipId" required>
            <option value="">Выберите чемпионат</option>
            <option *ngFor="let championship of championships" [value]="championship.id">{{ championship.name }}</option>
          </select>
        </label>
        <label class="logo-field">
          <span>Логотип</span>
          <input class="form-control" type="file" accept="image/png,image/jpeg,image/webp,image/gif" (change)="selectLogoFile($event)">
          <small>{{ selectedLogoFileName || 'PNG, JPG, WEBP или GIF до 2 МБ' }}</small>
        </label>
        <label>
          <span>Город</span>
          <input class="form-control" name="city" [(ngModel)]="formData.city">
        </label>
        <label>
          <span>Год основания</span>
          <input class="form-control" type="number" name="foundationYear" [(ngModel)]="formData.foundationYear">
        </label>
        <label>
          <span>Название арены</span>
          <input class="form-control" name="arenaName" [(ngModel)]="formData.arenaName">
        </label>
        <label>
          <span>Вместимость арены</span>
          <input class="form-control" type="number" name="arenaCapacity" [(ngModel)]="formData.arenaCapacity">
        </label>
        <label>
          <span>Сайт</span>
          <input class="form-control" type="url" name="websiteUrl" [(ngModel)]="formData.websiteUrl">
        </label>
        <label>
          <span>Telegram</span>
          <input class="form-control" type="url" name="telegramUrl" [(ngModel)]="formData.telegramUrl">
        </label>
        <label>
          <span>ВКонтакте</span>
          <input class="form-control" type="url" name="vkUrl" [(ngModel)]="formData.vkUrl">
        </label>
      </div>
    </section>

    <aside class="form-card actions-card">
      <button class="save-button" type="submit" [disabled]="saving || !formData.championshipId || !formData.slug">{{ saving ? 'Сохраняем...' : mode === 'edit' ? 'Сохранить' : 'Создать команду' }}</button>
      <a class="cancel-link" routerLink="/dashboard/teams">Отмена</a>
    </aside>
  </form>
</section>
